module.exports = __webpack_public_path__ + "media/42.f614f7bc.mp3";